import * as productFruits from '@/utils/external/productFruits';
import firstPromoter from '@/utils/external/firstPromoter';
import hubspot from '@/utils/external/hubspot';
import utils from '@/utils/external/utils';

function enableAll() {
    firstPromoter.enable();
    hubspot.enable();
    productFruits.enable();
}

function disableAll() {
    firstPromoter.disable();
    hubspot.disable();
    productFruits.disable();
}

function trackPageview(data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'virtualPageView',
      virtualPage: data.path,
      user_id: data.user?.id,
    });

    hubspot.trackPageView(data);
}

function trackEvent(event, data = {}) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        ...data,
        event,
    });
}

function trackRegistration(data) {
    trackEvent('company_registered', {
        campaign: data.campaign,
        user_id: data.user.id,
    });
    firstPromoter.register(data);
    hubspot.identifyFromRegistration(data);
}

export default {
    enableAll,
    disableAll,
    trackPageview,
    trackEvent,
    trackRegistration,
    firstPromoter,
    hubspot,
    productFruits,
    injectScript: utils.injectScript,
};
